export function fitSvgToContainer(svg: string): string {
    return svg.replace(/<svg\b[^>]*>/, (rootTag) =>
        rootTag
            .replace(/\s(?:width|height)=(?:"[^"]*"|'[^']*')/g, '')
            .replace(/^<svg/, '<svg width="100%" height="100%"'),
    );
}